import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/Icons/iconRight.svg'


const _hoisted_1 = ["disabled"]
const _hoisted_2 = { class: "aba-button-content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)


export default /*#__PURE__*/_defineComponent({
  __name: 'aba-button',
  props: {
	class: { type: String, default: "" },
	btnType: { type: String, default: "" },
	btnSize: { type: String, default: "" },
	isDisabled: { type: Boolean, default: false },
},
  emits: ["click"],
  setup(__props, { emit: __emit }) {

// // Определение пропсов компонента
const props = __props;

// // Определение эмиттеров событий компонента
const emits = __emit;

function onClick() {
	if (props.isDisabled) return; // Если кнопка заблокирована
	emits("click"); // Вызываем событие click
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      class: _normalizeClass(["aba-button", [props.class, props.btnType, { disabled: props.isDisabled }, props.btnSize]]),
      onClick: onClick,
      disabled: props.isDisabled
    }, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _hoisted_3,
          _createTextVNode("  "),
          _createElementVNode("span", null, _toDisplayString(_ctx.$localization.getTranslate("Button.Login")), 1)
        ])
      ])
    ], 10, _hoisted_1)
  ]))
}
}

})